import { AxiosError } from 'axios';

import {
  ACCOUNT_PASSWORD_CHANGE_CHECK_FAILURE,
  ACCOUNT_PASSWORD_CHANGE_CHECK_REQUEST,
  ACCOUNT_PASSWORD_CHANGE_CHECK_SUCCESS,
  ACCOUNT_PASSWORD_CHANGE_POSTPONE_FAILURE,
  ACCOUNT_PASSWORD_CHANGE_POSTPONE_REQUEST,
  ACCOUNT_PASSWORD_CHANGE_POSTPONE_SUCCESS,
  ACCOUNT_PASSWORD_FIND_FAILURE,
  ACCOUNT_PASSWORD_FIND_REQUEST,
  ACCOUNT_PASSWORD_FIND_SUCCESS,
  ACCOUNT_PASSWORD_RESET_FAILURE,
  ACCOUNT_PASSWORD_RESET_REQUEST,
  ACCOUNT_PASSWORD_RESET_SUCCESS,
  ACCOUNT_PASSWORD_TOKEN_VALIDATE_FAILURE,
  ACCOUNT_PASSWORD_TOKEN_VALIDATE_REQUEST,
  ACCOUNT_PASSWORD_TOKEN_VALIDATE_SUCCESS,
} from '@app/store/actionTypes';

export function checkPasswordChange() {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_CHECK_REQUEST,
  };
}

export function checkPasswordChangeSuccess(payload: { isChanged: boolean }) {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_CHECK_SUCCESS,
    payload,
  };
}

export function checkPasswordChangeFailure(error: AxiosError) {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_CHECK_FAILURE,
    payload: error,
    error: true,
  };
}

export function findPassword(password: string) {
  return {
    type: ACCOUNT_PASSWORD_FIND_REQUEST,
    payload: password,
  };
}

export function findPasswordSuccess(payload: { message: string }) {
  return {
    type: ACCOUNT_PASSWORD_FIND_SUCCESS,
    payload,
  };
}

export function findPasswordFailure(error: AxiosError) {
  return {
    type: ACCOUNT_PASSWORD_FIND_FAILURE,
    payload: error,
    error: true,
  };
}

export function postponePasswordChange() {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_POSTPONE_REQUEST,
  };
}

export function postponePasswordChangeSuccess() {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_POSTPONE_SUCCESS,
  };
}

export function postponePasswordChangeFailure(error: AxiosError) {
  return {
    type: ACCOUNT_PASSWORD_CHANGE_POSTPONE_FAILURE,
    payload: error,
    error: true,
  };
}

export function resetPassword(email: string, token: string, password: string) {
  return {
    type: ACCOUNT_PASSWORD_RESET_REQUEST,
    payload: {
      email,
      token,
      password,
    },
  };
}

export function resetPasswordSuccess(payload: { message: string }) {
  return {
    type: ACCOUNT_PASSWORD_RESET_SUCCESS,
    payload,
  };
}

export function resetPasswordFailure(error: AxiosError) {
  return {
    type: ACCOUNT_PASSWORD_RESET_FAILURE,
    payload: error,
    error: true,
  };
}

export function validatePasswordToken(email: string, token: string) {
  return {
    type: ACCOUNT_PASSWORD_TOKEN_VALIDATE_REQUEST,
    payload: {
      email,
      token,
    },
  };
}

export function validatePasswordTokenSuccess() {
  return {
    type: ACCOUNT_PASSWORD_TOKEN_VALIDATE_SUCCESS,
  };
}

export function validatePasswordTokenFailure(error: AxiosError) {
  return {
    type: ACCOUNT_PASSWORD_TOKEN_VALIDATE_FAILURE,
    payload: error,
    error: true,
  };
}

export type AccountPasswordAction =
  | ReturnType<typeof checkPasswordChange>
  | ReturnType<typeof checkPasswordChangeSuccess>
  | ReturnType<typeof checkPasswordChangeFailure>
  | ReturnType<typeof findPassword>
  | ReturnType<typeof findPasswordSuccess>
  | ReturnType<typeof findPasswordFailure>
  | ReturnType<typeof postponePasswordChange>
  | ReturnType<typeof postponePasswordChangeSuccess>
  | ReturnType<typeof postponePasswordChangeFailure>
  | ReturnType<typeof resetPassword>
  | ReturnType<typeof resetPasswordSuccess>
  | ReturnType<typeof resetPasswordFailure>
  | ReturnType<typeof validatePasswordToken>
  | ReturnType<typeof validatePasswordTokenSuccess>
  | ReturnType<typeof validatePasswordTokenFailure>;
